'use strict';

/**
 * Base class for an Controller
 *
 * @category   Controller
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Marionette = require('backbone-marionette');

var Controller = Marionette.Object.extend({
    onDataReady: function(collections, ready, notReady) {
        collections = _.isArray(collections) ? collections : [collections];

        ready = _.isFunction(ready) ? ready.bind(this) : function() {};

        notReady = _.isFunction(notReady) ? notReady.bind(this) : App.rootView.mainRegion.currentView.showLoader.bind(App.rootView.mainRegion.currentView);

        var currentNavigationCounter = App.router.getNavigationCounter();

        if (App.isDataLoaded(collections)) {
            ready();
        } else {
            collections.forEach(function(collection){
                var collectionName = _.isString(collection) ? collection : _.result(collection, 'name');

                this.listenToOnce(App.vent, collectionName + ':load', function() {
                    if (
                        this.isRequestStillRelevant(currentNavigationCounter) &&
                        App.isDataLoaded(collections)
                    ) {
                        ready();
                    }
                }.bind(this));
            }.bind(this));

            notReady();
        }
    },

    //if App.router.navigate was called after onDataReady was called, this will be false
    isRequestStillRelevant: function(navigationCounter, collectionName) {
        return navigationCounter === App.router.getNavigationCounter();
    },
});

module.exports = Controller;